module.exports = __webpack_public_path__ + "static/img/aa2.a2f94d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/202104/aa2.png
// module id = vGO7
// module chunks = 0